@if (on === 'form') { <!-- FORM BUTTONS AND LINKS -->
    <div style="width:calc(100% - 10px); display:flex; margin-left: 10px; align-items: flex-end">
        <div style="flex: 1; font-weight: lighter">
            {{control.field.label}}:
        </div>
        <div>
            @if(control.field.btnOpts.navigateRoute) {
                <a [routerLink]="[control.field.btnOpts.navigateRoute, control.field.btnOpts.navParms]"
                    style="line-height: 18px; font-size: 14px; padding-top: 16px">{{control.value}}
                </a>    
            } @else {
                {{control.value}}
            }
        </div>
        <!-- Fixed width gutter, so values align down a column whether or not there is a hint,
             and wide enough for the two actions a pickLink field puts here -->
        <div style="width: 34px; display: flex; justify-content: flex-end; align-items: center">
            @if(control.field.hint) {
                <mat-icon
                    style="font-size: 18px; height: 18px; width: 18px"
                    [matTooltip]="control.field.hint"
                    matTooltipPosition="above">help</mat-icon>
            }
        </div>
    </div>
} @else {  <!-- GRID BUTTONS AND LINKS -->
    <a [style.text-align]="'left'"
    style="padding: 0px; line-height: 1.25"
        [routerLink]="[control.field.btnOpts.navigateRoute, control.field.btnOpts.navParms]"
        [style.pointer-events]="control.field.disable ? 'none' : 'auto'">
        {{control.value}}
    </a>
}
